import React from "react";
import { Button, Row, Col } from "react-bootstrap";

const TargetSubmitSection = (props) => {
	const setReload = props.setReload;

	const submitBtnStyle = {
		margin: "40px auto",
		display: "block",
		width: "25%",
	};

	return (
		<Row>
			<Col md="6">
				<Button
					type="reset"
					style={submitBtnStyle}
					onClick={() => setReload(true)}
				>
					Reset
				</Button>
			</Col>
			<Col md="6">
				<Button type="submit" style={submitBtnStyle}>
					Submit
				</Button>
			</Col>
		</Row>
	);
};

export default TargetSubmitSection;
